'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseUserProfileController=require('./baseUserProfileController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

EditUserModalController=(_dec=


































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class EditUserModalController extends BaseUserProfileController{static get $inject(){return['$modalInstance','user','userService','uiCommandFactory','onUserUpdated','uncaughtErrorHandler']}constructor($modalInstance,user,userService,uiCommandFactory,onUserUpdated,uncaughtErrorHandler){super(uncaughtErrorHandler,user);this._userService=userService;this._$modalInstance=$modalInstance;this._onUserUpdated=onUserUpdated;this._updateUserCommand=uiCommandFactory.makeForModal($modalInstance,this._updateCurrentUser.bind(this));this.emailErrorHandler=this.emailErrorHandler.bind(this)}onCancel(){this._$modalInstance.dismiss()}get updateUserCommand(){return this._updateUserCommand}get submissionResult(){return this._submissionResult}emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===409){return`Email address "${this.email}" is already in use.`}}}
async _updateCurrentUser(){
let updateResult=await this._userService.updateCurrentUserInfo({
firstName:this.firstName,
lastName:this.lastName,
phone:this.phone,
email:this.email});


this._submissionResult=updateResult;

if(!SocketResponse.succeeded(updateResult)){
return ModalSubmissionResult.KeepOpen;
}

this._onUserUpdated();

return ModalSubmissionResult.Close();
}},(_applyDecoratedDescriptor(_class.prototype,'_updateCurrentUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_updateCurrentUser'),_class.prototype)),_class));


module.exports=EditUserModalController;
//# sourceMappingURL=editUserModalController.js.map
